var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../BlocksElement';
import styles from './segmented-control.styles';
/**
 * @slot default - This displays sequence of segmented control item given
 * @fires bl-segment-item-change - emitted when user changes from one segmented-item to other
 * @csspart base - The component's base wrapper.
 * @csspart header - The component's header wrapper.
 * @csspart list - The component's list.
 * @csspart part-default - The component's default slot.
 */
export class BlocksSegmentedControl extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         * 1. Deactivate the previous active item to maintain single selection
         * 2. Activate the newly selected item based on activeIndex
         */
        this.handleIsActive = () => {
            if (this.activeIndex !== undefined && this.activeIndex >= 0 && this.activeIndex < this.segmentItemList?.length) {
                if (!this.segmentItemList[this.activeIndex].disabled && !this.segmentItemList[this.activeIndex].isLoading) {
                    if (this.activeSegmentItem) {
                        this.activeSegmentItem.isActive = false; /**1 */
                    }
                    this.activeSegmentItem = this.segmentItemList[this.activeIndex];
                    this.activeSegmentItem.isActive = true; /** 2 */
                }
            }
        };
    }
    static { this.styles = styles; }
    handleSegmentItemSelect(e) {
        if (this.activeSegmentItem) {
            this.activeSegmentItem.isActive = false;
        }
        this.activeSegmentItem = e.target;
        const activeIndex = this.segmentItemList.findIndex((segment) => segment === this.activeSegmentItem);
        this.activeIndex = activeIndex;
        this.dispatchSegmentChangeEvent();
    }
    /**
     * @fires SegmentItemChange
     */
    dispatchSegmentChangeEvent() {
        this.dispatch({
            eventName: 'bl-segment-item-change',
            detailObj: { activeIndex: this.activeIndex }
        });
    }
    updated(changedProperties) {
        if (changedProperties.has('activeIndex')) {
            this.handleIsActive();
        }
    }
    render() {
        const componentClassNames = this.componentClassNames('cat-c-segmented-control', {});
        return html `
      <div part="base" class="${componentClassNames}">
        <header part="header" class="cat-c-segmented-control__header">
          <div part="list" class="cat-c-segmented-control__list" role="group" aria-label=${ifDefined(this.arialabel)}>
            <slot part="part-default" @slotchange=${this.handleIsActive} @bl-segment-item-select=${this.handleSegmentItemSelect}></slot>
          </div>
        </header>
      </div>
    `;
    }
}
__decorate([
    property({ type: Number })
], BlocksSegmentedControl.prototype, "activeIndex", void 0);
__decorate([
    property({ type: String })
], BlocksSegmentedControl.prototype, "arialabel", void 0);
__decorate([
    queryAssignedElements({ flatten: true })
], BlocksSegmentedControl.prototype, "segmentItemList", void 0);
if (customElements.get('cat-segmented-control') === undefined) {
    customElements.define('cat-segmented-control', BlocksSegmentedControl);
}
